import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { filter, map, catchError } from 'rxjs/operators';

import { ReCaptchaV3Service } from 'ngx-captcha';
import { PaymentService } from '../payment.service';

import { environment } from '../http/environment';

@Component({
   selector: 'app-confirmation',
   templateUrl: './confirmation.component.html',
   styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {

   uuid: string;
   decision: string;
   ref: string;

   error = false;
   show_email = false;
   sending = false;
   email = new FormControl({ value: '', disabled: this.sending }, [ Validators.required, Validators.email ]);

   constructor(
      private route: ActivatedRoute,
      private router: Router,
      private payment: PaymentService,
      private changes: ChangeDetectorRef,
      private recaptcha: ReCaptchaV3Service,
   ) { }

   ngOnInit() {
      this.route.params.pipe(
         filter( params => params?.number ),
         map( params => params.number ),
      ).subscribe( uuid => {
         this.uuid = uuid;

         this.payment.getDetails( uuid ).pipe(
            catchError( err => {
               this.error = true;
               console.log( 'got response error', err.error.status.message );

               setTimeout( _ => this.router.navigate([ '/' ]), 3000 );

               throw err;
            }),
         ).subscribe({
            next: response => {
               this.decision = response.decision;
               this.ref = response.ref;
            },
            error: () => { },
         });
      });
   }

   check() {
      if ( this.email.invalid ) { return; }

      if ( !environment.production ) { return this.send(); }

      this.recaptcha.execute('6LchSnAUAAAAAMAHgohw2X1xgDNIEEqzf4p9gQBE', 'paymentEmail', token => {
         if ( token ) {
            this.send();
         } else {
            this.email.setErrors({ fail: true });
            this.changes.detectChanges();
         }
      });
   }

   send() {
      if ( this.email.invalid ) { return; }

      console.log( this.email.value );

      this.sending = true;
      this.payment.sendEmail({ uuid: this.uuid, address: this.email.value }).pipe(
         catchError( err => {
            if ( err.error.status.message ) {
               this.email.setErrors({ message: err.error.status.message });
            } else {
               this.email.setErrors({ fail: true });
            }
            this.changes.detectChanges();

            throw err;
         }),
      ).subscribe({
         next: _ => {
            this.email.reset();
            this.show_email = false;
         },
         error: () => { },
      });
   }
}
